'use client'

import Image from 'next/image'
import { FC } from 'react'

import CustomerStory from '@/components/CustomerStory'

const LuneCustomerStory: FC = () => {
    return (
        <CustomerStory
            light={true}
            hideLabel={true}
            backgroundImageSrc={'/images/customer-quotes/erik-quote-desktop.png'}
            mobileBackgroundImageSrc={'/images/customer-quotes/erik-quote-mobile.png'}
            logo={
                <Image
                    src={'/images/logos/lune-logo-white.png'}
                    height={32}
                    width={103.99}
                    alt={'Lune Story'}
                />
            }
            text={
                <>
                    We founded Lune to make prioritising climate impact a no-brainer for
                    growth-minded businesses.
                    <br />
                    <br />
                    By integrating it into their customer experience, businesses increase customer
                    acquisition, engagement, and loyalty – while having a measurably positive impact
                    on the planet.
                </>
            }
            avatar={{
                title: 'Erik Stadigh',
                subtitle: 'Co-Founder and CEO at Lune',
                imageSrc: '/images/avatars/lune-customer-story-avatar.png',
            }}
        />
    )
}

export default LuneCustomerStory
